import type { WorkflowUiPhase, WorkflowUserMessage } from '@/components/workflow/types';

export const FLOW_CONFIRM_APPROVE_MESSAGE = 'Confirm';

export function hasFlowApproveMessage(messages: WorkflowUserMessage[]): boolean {
  return messages.some((message) => message.id.startsWith('approve-'));
}

export function shouldShowFlowConfirmCta(input: {
  uiPhase: WorkflowUiPhase;
  formStep: string;
  userMessages: WorkflowUserMessage[];
  steps: ReadonlyArray<{ id: string }>;
}): boolean {
  if (input.uiPhase !== 'form') return false;
  if (hasFlowApproveMessage(input.userMessages)) return false;

  const hasConfirmStep = input.steps.some((step) => step.id === 'confirm');
  if (hasConfirmStep) return input.formStep === 'confirm';

  const lastStepId = input.steps[input.steps.length - 1]?.id;
  return Boolean(lastStepId && input.formStep === lastStepId);
}
